import HcLocalizer from '../HcLocalizer';

export default class HcLocalizerVuePlugin {

    private static readonly propertyName: string = '$hcLocalizer';
    private static readonly filterName: string = 'localize';

    public static install(Vue: any, options: any): void {
        var localizer: HcLocalizer = this.getInstance(Vue, options);

        this.registerVueProperty(Vue, localizer);
        this.registerGlobalMethod(Vue, localizer);
        this.registerFilter(Vue, localizer);

        if (options.routes && options.router) {
            this.registerLocalizedRoutes(options.routes, options.router, localizer);
        }
    }

    private static getInstance(Vue: any, options: any): HcLocalizer {
        let instance: HcLocalizer | undefined;

        if (Vue.prototype.hasOwnProperty(this.propertyName)) {
            instance = Vue.prototype[this.propertyName] as HcLocalizer;
            !!options && instance.addOptions(options);
        } else {
            instance = new HcLocalizer(options);
        }

        return instance;
    }

    private static registerVueProperty(Vue: any, localizer: HcLocalizer) {
        if (!Vue.prototype.hasOwnProperty(this.propertyName)) {
            Object.defineProperty(Vue.prototype, this.propertyName, {
                get () {
                    return localizer
                }
            });
        }
    }

    private static registerGlobalMethod(Vue: any, localizer: HcLocalizer) {
        Vue.prototype.$localize = (key: string, ...parameters: any[]): string => {
            return localizer.getTranslation(key, ...parameters);
        };
    }

    private static registerFilter(Vue: any, localizer: HcLocalizer) {
        Vue.filter(this.filterName, (key: string, ...parameters: any[]) => {
            return localizer.getTranslation(key, ...parameters);
        });
    }

    private static registerLocalizedRoutes(routes: object[], router: any, localizer: HcLocalizer) {
        routes.forEach((route: any) => {
            route.path = localizer.getTranslation(route.path);
        });
        router.addRoutes(routes);
    }
}
